<template>
    <div>
        <div class="chat-box bg-white px-2 py-2" ref="chatBox" v-if="ready">
            <div
                class="media w-75"
                v-for="(message, index) in messages"
                :key="index"
                v-bind:class="{
                    '': message.user !== user.uid,
                    'ml-auto': message.user === user.uid,
                }"
            >
                <div
                    class="media-body"
                    v-bind:class="{
                        'ml-3': message.user !== user.uid,
                        '': message.user === user.uid,
                    }"
                >
                    <div
                        class="rounded py-2 px-3 mb-2"
                        v-bind:class="{
                            'bg-light': message.user !== user.uid,
                            'bg-primary': message.user === user.uid,
                        }"
                    >
                        <p
                            class="text-small mb-0 message-body"
                            v-bind:class="{
                                'text-muted': message.user !== user.uid,
                                'text-white': message.user === user.uid,
                            }"
                        >
                            {{ message.rawBody }}
                        </p>
                    </div>
                    <p
                        class="small text-muted timestamp"
                        v-b-tooltip.hover
                        :title="message.createdAt | readableDateTime"
                    >
                        <vue-moments-ago
                            prefix
                            suffix="ago"
                            :date="message.createdAt"
                        ></vue-moments-ago>
                    </p>
                </div>
            </div>
        </div>

        <div class="row" v-else>
            <div
                class="col-12 d-flex flex-row justify-content-center align-items-center"
                style="height: 240px"
            >
                <img src="/img/spinner.gif" height="100" alt />
            </div>
        </div>

        <form @submit="send" v-on:submit.prevent class="bg-light">
            <div class="input-group">
                <input
                    type="text"
                    placeholder="Type a message"
                    aria-describedby="button-addon2"
                    class="form-control rounded-0 border-0 py-4 bg-light"
                    required
                    v-model="body"
                />
                <div class="input-group-append">
                    <button
                        id="button-addon2"
                        type="submit"
                        class="btn btn-link"
                    >
                        <i class="las la-paper-plane"></i>
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { api } from "../config";
import firebase from "firebase";
import { mapGetters } from "vuex";
import { db } from "../main";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import VueMomentsAgo from "vue-moments-ago";
export default {
    props: {
        email: String,
    },
    data: () => ({
        customer: {
            name: "",
            email: "",
            contactNumber: "",
        },
        response: {},
        channel: {},
        messages: [],
        body: "",
        disabledButton: true,
        ready: false,
        agentTyping: false,
    }),
    computed: {
        ...mapGetters({
            loggedIn: "loggedIn",
            user: "user",
            signInUser: "signInUser",
            channelId: "channelId",
            token: "token"
        }),
    },
    async mounted() {
        setTimeout(() => {
            if(!this.signInUser) this.loginAsGuest()
            else this.getMessages()
        }, 3000)
        
    },
    methods: {
        async loginAsGuest() {
            let self = this;
            let request = await fetch(`${api}/users/guest`, {
                method: "POST",
                body: JSON.stringify(this.customer),
                headers: {
                    "Content-Type": "application/json",
                },
            });
            self.response = await request.json();
            firebase
                .auth()
                .signInWithCustomToken(self.response.token)
                .then(async () => {
                    self.$store.dispatch("setUser", self.response.user);
                    self.$store.dispatch(
                        "setToken",
                        await firebase.auth().currentUser.getIdToken(true)
                    );

                    let request = await fetch(`${api}/channels`, {
                        method: "POST",
                        body: JSON.stringify({
                            user: self.response.user.uid,
                            website: self.$id,
                        }),
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${self.$store.getters.token}`,
                        },
                    });
                    let response = await request.json();
                    self.$store.dispatch("setChannel", response.uid);
                    self.$store.dispatch("login");
                    self.$store.dispatch("signInUser");
                    self.getMessages();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        async getMessages() {
            let self = this;
            let request = await fetch(
                `${api}/channels/messages/${this.channelId}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${this.$store.getters.token}`,
                    },
                }
            );
            let response = await request.json();
            if(response.code && response.code === 'auth/id-token-expired') {
                self.$store.dispatch("resetState");
                window.location.reload();
            }

            this.channel = response.channel;
            this.messages = response.messages;
            await this.scrollToBottom();
            this.ready = true;

            db.collection("channels")
                .doc(this.channelId)
                .onSnapshot(async (doc) => {
                    let message = doc.data();
                    let index = self.messages.findIndex(
                        (m) => m.uid === message.uid
                    );
                    if (index < 0) {
                        self.messages.push(message);

                        self.scrollToBottom();

                        if (message.user !== self.user.uid) {
                            setTimeout(async () => {
                                await self.updateMessageReceipt(message.uid);
                            }, 1000);
                        }
                    }
                });

            // db.collection("activities")
            //     .doc(this.channelId)
            //     .onSnapshot(async (doc) => {
            //         let activity = doc.data();
            //         this.agentTyping = activity.agentTyping;
            //     });
        },
        async send() {
            if (this.body.length) {
                let message = {
                    uid: uuidv4(),
                    user: this.user.uid,
                    userType: "customer",
                    rawBody: this.body,
                    body: this.body,
                    createdAt: moment().format(),
                    active: true,
                };

                this.body = "";

                await db
                    .collection("channels")
                    .doc(this.channelId)
                    .set(message);
            }
        },
        scrollToBottom() {
            let self = this;
            let duration = self.ready ? 0 : 500;
            setTimeout(() => {
                self.$refs.chatBox.scrollTop =
                    self.$refs.chatBox.scrollHeight -
                    self.$refs.chatBox.clientHeight;
            }, duration);
        },
        async updateMessageReceipt(messageId) {
            await fetch(`${api}/channels/messages/receipts`, {
                method: "POST",
                body: JSON.stringify({
                    message: messageId,
                }),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${this.$store.getters.token}`,
                },
            });
        },
    },
    components: {
        VueMomentsAgo,
    },
};
</script>

<style>
::-webkit-scrollbar {
    width: 5px;
}

::-webkit-scrollbar-track {
    width: 5px;
    background: #f5f5f5;
}

::-webkit-scrollbar-thumb {
    width: 1em;
    background-color: #ddd;
    outline: 1px solid slategrey;
    border-radius: 1rem;
}

.text-small {
    font-size: 0.9rem;
}

.messages-box,
.chat-box {
    height: 300px;
    overflow-y: scroll;
}
.typing-indicator {
    height: 25px;
}

.rounded-lg {
    border-radius: 0.5rem;
}

input::placeholder {
    font-size: 0.9rem;
    color: #999;
}
.timestamp {
    font-size: 0.7rem !important;
}
.message-body {
    white-space: pre-line;
}
</style>
